
import Vue from 'vue';
import Datepicker from 'vuejs-datepicker';
/**
- if want to change input text color, modify .eu-datepicker-container .vdp-datepicker input
- This datepicker is based on library vuejs-datepicker, you can pass any its exact props to this component
**/
export default Vue.extend<any, any, any, any>({
  name: 'DatePicker',
  components: {
    Datepicker
  },
  props: {
    /**
     * Set value on datepicker
     */
    value: {
      type: [String, Date],
      default: ''
    },
    /**
     * Set id on datepicker
     */
    id: {
      type: String,
      default: ''
    },
    /**
     * Set placeholder
     */
    placeholder: {
      type: String,
      default: 'Input date here'
    },
    /**
     * Set input on error state
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * Set input on success state
     */
    success: {
      type: Boolean,
      default: false
    },
    /**
     * Set disabled dates {from: , to: }
     */
    disabledDate: {
      type: Object,
      default: () => {}
    },
    /**
     * Set date format
     */
    dateFormat: {
      type: String,
      default: 'dd MMM yyyy'
    }
  },
  data() {
    return {
      date: ''
    };
  },
  watch: {
    value() {
      this.date = this.value;
    }
  },
  created() {
    this.date = this.value;
  },
  computed: {
    containerClasses() {
      return {
        error: this.error,
        success: this.success,
        disabled: this.$attrs.disabled === true
      };
    }
  },
  methods: {
    handleInput(e: Event) {
      /**
       * Method to input date value
       * @event input
       * @type {function}
       */
      this.$emit('input', e);
    },
    handleClick(e: Event) {
      /**
       * Method to click date input container
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    }
  }
});
